import { MoreVert } from "@mui/icons-material";
import { Button, Menu } from "@mui/material";
import React, { useEffect, useState } from "react";
import { OrganizationContent } from "../components";
import {
	ApplicationGuideText,
	ApplicationGuideWrapper,
	ApplicationIcon,
	ApplicationMenuButton,
	ApplicationMenuItem,
	ApplicationName,
	ApplicationNameWrapper,
	ModalTitle,
} from "./style";
import AndroidIcon from "@/assets/img/ic_application_android.svg";
import Table from "@/components/Table/Table";
import useOrganizationInfoRequestThunk from "@/hooks/Organization/useOrganizationInfoRequestThunk";
import { useDispatch, useSelector } from "react-redux";
import { getApplicationInfo, getCompanyDetailInfo } from "@/redux/organization/selector";
import { format } from "date-fns";
import Modal from "@/components/Modal";
import Input from "@/components/Input";
import useCustomFormik from "@/hooks/formik/useCustomFormik";
import { AppInfoResponseDto, AppResponseDto, AppUpsertRequestDto } from "@/api/interface";
import { useSnackbar } from "notistack";
import API from "@/api/serverCall";
import {
	deleteApplicationInfoById,
	setApplicationInfoById,
} from "@/redux/organization/actions";
import useGetUserInfoRequest from "@/hooks/user/useGetUserInfoRequest";
import { getUserInfo } from "@/redux/user/selector";
import AddIcon from "@mui/icons-material/Add";
import CreateAppDialog from "@/views/Home/ApplicationSection/Components/CreateAppDialog";
import { applicationInfoType } from "types/app";
import { useTranslation } from "react-i18next";

interface InitialValues {
	appName: string;
	changeAppName: string;
}

export default function OrganizationApplications() {
	useOrganizationInfoRequestThunk();
	useGetUserInfoRequest();
	const { t, i18n } = useTranslation();
	// const tempApplicationInfo = useSelector(getApplicationInfo);
	const companyDetailInfo = useSelector(getCompanyDetailInfo);
	const userInfo = useSelector(getUserInfo);
	/* if (!userInfo) {
		return <></>;
	} */
	// const applicationInfo = companyDetailInfo?.body.apps;
	const responseAppInfo = companyDetailInfo?.body.apps.map((app) => {
		return {
			id: app.id,
			name: app.name,
			packageAndroid: app.packageAndroid,
			packageIos: app.packageIos,
			companyToken: "",
			appToken: app.appToken,
			nextPaymentAt: app.nextPaymentAt,
			createdAt: app.createdAt,
			isFoodLens: app.isFoodLens,
		};
	});
	const [applicationInfo, setApplicationInfo] = React.useState<
		applicationInfoType[] | undefined
	>(responseAppInfo);
	const dispatch = useDispatch();
	const { enqueueSnackbar } = useSnackbar();
	const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
	const [createModal, setCreateModal] = useState<boolean>(false);
	const handleModalClose = () => {
		setCreateModal(false);
	};
	const [renameModal, setRenameModal] = useState<boolean>(false);
	const [deleteModal, setDeleteModal] = useState<boolean>(false);
	const [selectedModalData, setSelectedModalData] =
		useState<applicationInfoType | null>(null);
	const [menuData, setMenuData] = useState<null | applicationInfoType>(null);

	const open = Boolean(menuAnchor);

	const initialValues: InitialValues = {
		appName: "",
		changeAppName: "",
	};

	const { values, getFieldProps, setFieldValue } = useCustomFormik<InitialValues>({
		initialValues,
		onSubmit: () => {
			//
		},
	});

	useEffect(() => {
		if (!companyDetailInfo) {
			return;
		}
		const responseAppInfo = companyDetailInfo.body.apps.map((app) => {
			return {
				id: app.id,
				name: app.name,
				packageAndroid: app.packageAndroid,
				packageIos: app.packageIos,
				companyToken: "",
				appToken: app.appToken,
				nextPaymentAt: app.nextPaymentAt,
				createdAt: app.createdAt,
				isFoodLens: app.isFoodLens,
			};
		});
		setApplicationInfo(responseAppInfo);
	}, [companyDetailInfo]);

	const handleMenuClick = (
		event: React.MouseEvent<HTMLElement>,
		// appInfo: AppResponseDto,
		appInfo: applicationInfoType,
	) => {
		setMenuAnchor(event.currentTarget);
		setMenuData(appInfo);
	};
	const handleMenuClose = () => {
		setMenuAnchor(null);
		setMenuData(null);
	};

	const handleOpenRenameModal = (v: applicationInfoType) => {
		setRenameModal(true);
		setSelectedModalData(v);
	};

	const handleOpenDeleteModal = (v: applicationInfoType) => {
		setDeleteModal(true);
		setSelectedModalData(v);
	};

	const handleCloseRenameModal = () => {
		setFieldValue("changeAppName", "");
		setRenameModal(false);
		setSelectedModalData(null);
	};

	const handleCloseDeleteModal = () => {
		setFieldValue("appName", "");
		setDeleteModal(false);
		setSelectedModalData(null);
	};

	const handleClickRename = () => {
		if (!menuData) {
			return;
		}

		handleOpenRenameModal(menuData);
	};

	const handleClickRenameButton = async () => {
		if (!selectedModalData) {
			return;
		}

		try {
			const body: AppUpsertRequestDto = {
				id: selectedModalData.id,
				name: values.changeAppName,
				packageAndroid: "",
				packageIos: "",
			};
			const { data } = await API.patch<AppResponseDto>({
				body,
				link: "/app",
			});

			dispatch(setApplicationInfoById(data));
			setApplicationInfo(
				applicationInfo?.map((app) =>
					app.id === selectedModalData.id
						? { ...app, name: values.changeAppName }
						: app,
				),
			);
			handleCloseRenameModal();
			enqueueSnackbar(t("application_change_name.success"), {
				variant: "success",
			});
		} catch (e) {
			enqueueSnackbar(t("application.error"), {
				variant: "error",
			});
		}
	};

	const handleClickDelete = () => {
		if (!menuData) {
			return;
		}

		handleOpenDeleteModal(menuData);
	};

	const handleClickDeleteButton = async () => {
		if (!selectedModalData) {
			return;
		}

		try {
			await API.delete<AppResponseDto>({
				link: `/app/${selectedModalData.id}`,
			});

			dispatch(deleteApplicationInfoById(selectedModalData.id));
			setApplicationInfo(
				applicationInfo?.filter((app) => app.id !== selectedModalData.id),
			);
			handleCloseDeleteModal();
			enqueueSnackbar(t("application_delete.success"), {
				variant: "success",
			});
		} catch (e) {
			enqueueSnackbar(t("application.error"), {
				variant: "error",
			});
		}
	};

	if (!applicationInfo) {
		return null;
	}

	return (
		<OrganizationContent title={t("application_title")}>
			<Modal
				titleText={t("application_change_name")}
				handleClose={handleCloseRenameModal}
				open={renameModal}
				cancelButtonText={t("application_change_name_cancel")}
				submitButtonText={t("application_change_name_save")}
				handleClickCancelButton={handleCloseRenameModal}
				disabledSubmitButton={!values.changeAppName}
				handleClickSubmitButton={handleClickRenameButton}
			>
				<>
					<ModalTitle>{t("application_change_name_input_title")}</ModalTitle>
					<Input
						placeholder={t("application_change_name.guide")}
						{...getFieldProps("changeAppName")}
					/>
				</>
			</Modal>
			<Modal
				titleText={t("application_delete.title")}
				handleClose={handleCloseDeleteModal}
				open={deleteModal}
				cancelButtonText={t("application_delete.cancel")}
				submitButtonText={t("application_delete.delete")}
				handleClickCancelButton={handleCloseDeleteModal}
				disabledSubmitButton={values.appName !== selectedModalData?.name}
				handleClickSubmitButton={handleClickDeleteButton}
			>
				<>
					<ModalTitle>
						{t("application_delete.guide")}
						<span style={{ color: "#df2222" }}>
							{selectedModalData?.name}
						</span>
					</ModalTitle>
					<Input
						placeholder={t("application_delete.guide")}
						{...getFieldProps("appName")}
					/>
				</>
			</Modal>
			{userInfo != null && (
				<CreateAppDialog
					openModal={createModal}
					setModalOpen={setCreateModal}
					handleModalClose={handleModalClose}
					applicationInfo={applicationInfo}
					setApplicationInfo={setApplicationInfo}
					defaultEmail={userInfo.email}
				/>
			)}
			<ApplicationGuideWrapper>
				<ApplicationGuideText>
					{i18n.language === "ko" && (
						<>
							최대 {companyDetailInfo?.body.maxApp}개의 애플리케이션을 만들
							수 있습니다. 현재 {applicationInfo.length}개의 애플리케이션이
							있습니다.
						</>
					)}
					{i18n.language === "en" && (
						<>
							You can create up to {companyDetailInfo?.body.maxApp}
							applications. Currently, you have {applicationInfo.length}
							applications.
						</>
					)}
				</ApplicationGuideText>
				<Button
					variant="outlined"
					endIcon={<AddIcon />}
					onClick={() => {
						setCreateModal(true);
					}}
					sx={{
						color: "white",
						borderColor: "#a9a9a9",
						height: "2.5rem",
						alignSelf: "center",
						backgroundColor: "#0071E3",
						"&:hover": { backgroundColor: "rgb(2 95 189)" },
					}}
				>
					{t("application_add_button")}
				</Button>
			</ApplicationGuideWrapper>

			<Table
				col={[55, 20, 20, 5]}
				headItems={[
					t("application_name"),
					t("application_api"),
					t("application_created_at"),
					"",
				]}
				rowItems={applicationInfo.map((appInfo) => [
					<ApplicationNameWrapper>
						<ApplicationIcon>
							<img src={AndroidIcon} alt="application icon" />
						</ApplicationIcon>
						<ApplicationName>{appInfo.name}</ApplicationName>
					</ApplicationNameWrapper>,
					<div style={{ fontWeight: 700 }}>
						{appInfo.isFoodLens ? "FoodLens" : "CaloAI"}
					</div>,
					i18n.language === "ko"
						? format(new Date(appInfo.createdAt), "yyyy년 MM월 dd일")
						: new Date(appInfo.createdAt).toLocaleString("en-US", {
								month: "long",
								year: "numeric",
								day: "numeric",
						  }),
					userInfo?.isOwner && (
						<>
							<ApplicationMenuButton
								onClick={(e) => handleMenuClick(e, appInfo)}
							>
								<MoreVert />
							</ApplicationMenuButton>
							<Menu
								open={open}
								anchorEl={menuAnchor}
								anchorOrigin={{
									horizontal: "right",
									vertical: "bottom",
								}}
								transformOrigin={{
									vertical: "top",
									horizontal: "right",
								}}
								onClose={handleMenuClose}
							>
								<ApplicationMenuItem onClick={handleClickRename}>
									{t("application_change_name")}
								</ApplicationMenuItem>
								<ApplicationMenuItem onClick={handleClickDelete}>
									{t("application_delete")}
								</ApplicationMenuItem>
							</Menu>
						</>
					),
				])}
			/>
		</OrganizationContent>
	);
}
